"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReCAPTCHA = void 0;
const react_1 = __importDefault(require("react"));
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const error_message_1 = require("@hookform/error-message");
const react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
const inputErrorTranslations_1 = require("./helpers/inputErrorTranslations");
const ReCAPTCHA = ({ property, classNamePrefix, context }) => {
    var _a;
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const handleRecaptchaSuccess = (token) => {
        if (token) {
            context.setValue(property, token);
        }
    };
    const handleRecaptchaExpired = () => {
        context.setValue(property, undefined);
    };
    return (react_1.default.createElement("div", { className: `${classNamePrefix}-form-captcha-input-container` },
        react_1.default.createElement("div", { className: `${classNamePrefix}-form-captcha-input-box` },
            react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: process.env.GATSBY_RECAPTCHA_KEY, onChange: handleRecaptchaSuccess, onExpired: handleRecaptchaExpired }),
            react_1.default.createElement("input", Object.assign({ className: `${classNamePrefix}-form-captcha-input${(_a = (context.formState.errors[`${property}`] && ` ${classNamePrefix}-form-text-input-error`)) !== null && _a !== void 0 ? _a : ""}`, type: "hidden" }, context.register(property, {
                required: inputErrorTranslations_1.translations[currentLocale].required,
            })))),
        react_1.default.createElement(error_message_1.ErrorMessage, { errors: context.formState.errors, name: property, render: ({ message }) => react_1.default.createElement("p", { className: `${classNamePrefix}-form-text-input-error-message` }, message) })));
};
exports.ReCAPTCHA = ReCAPTCHA;
//# sourceMappingURL=ReCAPTCHA.js.map